import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { getPropensioState } from './helpers';

import { LenderStatus } from '../constants';

interface PropensioStatusContentHook {
  state: LenderStatus;
  isIntroduced: boolean;
}

export default function usePropensioStatusContent(): PropensioStatusContentHook {
  const { job, credit, deposit, isLoading } = useStatusContext();

  const isIntroduced = useMemo(() => Boolean(job?.introduced_to), [job]);

  const state = useMemo((): LenderStatus => {
    if (isLoading || !job || !credit) return 'loading';
    return getPropensioState(job, credit, deposit);
  }, [job, credit, deposit, isLoading]);

  return {
    state,
    isIntroduced,
  };
}
